import React from 'react';
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {CONTENT_TYPES} from "@/constants";
import {clamp, getCssSizeValue, getItemType, getMapKey} from "@/utils/utils";
import dynamic from "next/dynamic";

const ImageTextLinkBlock = dynamic(() => import('@/components/payment/RightBlocks/ImageTextLinkBlock'), {
	loading: () => null,
	ssr: false
});
const ImageTextAccountBlock = dynamic(() => import('@/components/payment/RightBlocks/ImageTextAccountBlock'), {
	loading: () => null,
	ssr: false
});
const GridDonateBlock = dynamic(() => import('@/components/payment/RightBlocks/GridDonateBlock'), {
	loading: () => null,
	ssr: false
});

const VARIANT = {
	SINGLE: 'single',
	DOUBLE: 'double',
	TRIPLE: 'triple',
}

const RightElementsGridContainer = styled.div`
	display: grid;
	flex-direction: column;
	height: 100%;
	width: 100%;
	gap: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
    &.variant{
        &-${VARIANT.SINGLE}{
            grid-template-columns: 1fr;
        }
        &-${VARIANT.DOUBLE}{
            grid-template-columns: 1fr;
        }
        &-${VARIANT.TRIPLE}{
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 2fr 1fr;
            .grid-item-3{
                grid-column: 1/3;
            }
        }
    }
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		column-gap: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};
		row-gap: ${getCssSizeValue(16, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        column-gap: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
        row-gap: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
        &.variant{
            &-${VARIANT.DOUBLE}{
                grid-template-columns: 1fr 1fr;
            }
        }
	}
	
	
`

const RightModuleBlockItem = ({className, data}) => {
	const type = getItemType(data)
	switch (type) {
		case CONTENT_TYPES.GLOBAL_PAYMENT_RIGHT_IMAGE_TEXT_LINK_BLOCK:
			return <ImageTextLinkBlock className={className} data={data}/>
		case CONTENT_TYPES.GLOBAL_PAYMENT_RIGHT_IMAGE_TEXT_ACCOUNT_BLOCK:
			return <ImageTextAccountBlock className={className} data={data}/>
		case CONTENT_TYPES.GLOBAL_PAYMENT_BANNER_KRS:
			return <GridDonateBlock className={className} data={data}/>
		default:
			return null
	}
}

const A_VARIANT = Object.entries(VARIANT)

const RightSide = ({ data }) => {
	const arr = Array.isArray(data) ? data : []
	const variant = A_VARIANT[clamp(arr.length - 1, 0, 2)][1] || VARIANT.SINGLE
	return (
		<RightElementsGridContainer className={`variant-${variant}`}>
			{arr.map((item, index) => (
				<RightModuleBlockItem className={`grid-item-${index + 1}`} key={getMapKey(item)} data={item}/>
			))}
		</RightElementsGridContainer>
	);
};

export default RightSide;
